import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IMethodsAnalytes } from '../../models/methods-analytes/methods-analytes';
import { MethodsAnalytesService } from '../../services/methods-analytes/methods-analytes.service';

@Component({
  selector: 'app-methods-analytes',
  templateUrl: './methods-analytes.component.html',
  styleUrls: ['./methods-analytes.component.scss']
})
export class MethodsAnalytesComponent {
  methodsAnalytesList: IMethodsAnalytes[] = [];

  requestForm = new UntypedFormGroup({
    searchBy: new UntypedFormControl('Analyte'),
    search: new UntypedFormControl('', [Validators.required])
  });

  displayedColumns: string[] = ['analyteCode', 'analyte', 'methodCode', 'methodReference', 'revision', 'approved', 'air', 'drinkingWater', 'nonPotable', 'solids', 'tissue'];
  dataSource = new MatTableDataSource<IMethodsAnalytes>(this.methodsAnalytesList);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(private methodsAnalyteService: MethodsAnalytesService) { }

  filterTable(value: string) {
    this.dataSource.filter = value.trim().toLowerCase();
  }

  submitRequest() {
    if (this.requestForm.valid) {
      let request = this.requestForm.value;
      this.methodsAnalyteService.getMethodAnalytes(request.searchBy, request.search).subscribe(
        response => this.methodsAnalytesList = response,
        error => console.log("error", error),
        () => {
          this.dataSource = new MatTableDataSource<IMethodsAnalytes>(this.methodsAnalytesList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }
  }

}
